var isRecord = function (val) {
    return val !== null && typeof val === "object";
};
var hasMessage = function (val) {
    return isRecord(val) && "message" in val;
};
var getFirstErrorPath = function (obj, path) {
    if (path === void 0) { path = ""; }
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        var value = obj[key];
        var currentPath = path ? "".concat(path, ".").concat(key) : key;
        if (hasMessage(value)) {
            return currentPath;
        }
        if (isRecord(value)) {
            var nestedPath = getFirstErrorPath(value, currentPath);
            if (nestedPath)
                return nestedPath;
        }
    }
    return null;
};
export var scrollToError = function (errors) {
    var firstErrorField = getFirstErrorPath(errors);
    if (firstErrorField) {
        var errorElement = document.querySelector("[name=\"".concat(firstErrorField, "\"]"));
        if (errorElement instanceof HTMLElement) {
            errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
            errorElement.focus();
        }
    }
};
